import { Component, OnDestroy } from '@angular/core';
import { CheckForUpdateService } from '@assetaccountant/core/services/check-for-update.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-release-notes',
  templateUrl: './release-notes-modal.component.html',
  standalone: false,
})
export class ReleaseNotesModalComponent implements OnDestroy {
  get featuresByMonth() {
    return this.checkForUpdateService.getAllFeaturesByMonth();
  }

  get isVersionPending() {
    return this.checkForUpdateService.isVersionPending;
  }

  private markAsRead = false;

  constructor(
    private modal: NgbActiveModal,
    private checkForUpdateService: CheckForUpdateService,
  ) {}

  ngOnDestroy(): void {
    if (this.markAsRead) {
      this.checkForUpdateService.markAsRead();
    }
  }

  updateVersion() {
    this.checkForUpdateService.updateVersion();
  }

  onClose() {
    this.markAsRead = true;
    this.modal.close();
  }
}
